<app-page>
  <app-page-title 
    [title]="'STANDARD-CATEGORIES.ADMIN.TITLE' | translate"
  >
    @if(isAuthenticated) {
      <dx-button
        [disabled]="!selectedStandardCategoryIds.length"
        class="cta-btn"
        type="default"
        [text]="'COMMON.DELETE' | translate"
        (click)="deleteSelectedStandardCategories()"
      ></dx-button>
      <dx-button
        class="cta-btn"
        type="normal"
        icon="add"
        [text]="'STANDARD-CATEGORIES.ADMIN.ADD-STANDARD-CATEGORY' | translate"
        (click)="newStandardCategoryNavigateHandler()"
      ></dx-button>
    }
  </app-page-title>

  <app-admin-login
    *ngIf="!isAuthenticated && isLoaded"
    (loginSuccess)="onLoginSuccess()"
  ></app-admin-login>

  <div *ngIf="isAuthenticated || !isLoaded">
    <app-table
      [data]="standardTrainingCategories"
      [columns]="standardTrainingCategoryColumns"
      [showSearch]="true"
      [searchLabel]="'COMMON.SEARCH' | translate"
      [searchPlacehoder]="'COMMON.SEARCH' | translate"
      (onRowClick)="standardCategoryNavigateHandler($event)"
      [showSelection]="true"
      (selectHandler)="onStandardCategorySelected($event)"
      [showGrouping]="true"
      [stateKey]="stateKey"
      [templates]="{
        standardCategoryAttentionTemplate: standardCategoryAttentionTemplate
      }"
    ></app-table>
    <ng-template
        #standardCategoryAttentionTemplate
        let-data
      >
        <ng-container *ngIf="data.data as category">
          <div
            *ngIf="!category.imageFile"
            class="standard-category-attention"
            [title]="'STANDARD-CATEGORIES.ADMIN.MISSING-IMAGE' | translate"
          >
            !
          </div>
        </ng-container>
      </ng-template>
  </div>
</app-page>
